// @flow
import type { MessageDescriptor } from 'react-intl';

export type AnnotationThreadError = {
    message: MessageDescriptor,
    title: MessageDescriptor,
};
